import * as React from "react";
import { useGetUserRoles } from "./useGetUserRoles";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { isValidSession } from "user-management/src/cognito/kahunUserAuth";
import { UserRoles } from "fe-common/graphql";

//region [[ Props ]]
export interface RoleRestrictorProps {
  children?: JSX.Element | JSX.Element[];
  roles: UserRoles[];
  // Whether to redirect to login page
  redirect?: boolean;
  // If set to true we will show a loading message while we fetch the user status
  showLoading?: boolean;
}
//endregion [[ Props ]]

//region [[ Functions ]]

//endregion [[ Functions ]]
export const RoleRestrictor = ({
  showLoading,
  ...props
}: RoleRestrictorProps) => {
  const { roles, loading } = useGetUserRoles();

  const history = useHistory();

  const [checking, setChecking] = useState(true);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setChecking(true);
    try {
      isValidSession()
        .then((userAuth) => {
          setIsLoggedIn(!!userAuth);
        })
        .finally(() => setChecking(false))
        .catch((e) => console.error(e));
    } catch (e) {
      setIsLoggedIn(false);
      setChecking(false);
    }
  }, [loading]);

  if (
    props.roles.length &&
    props.roles.every((r) => !roles.includes(r)) &&
    !loading &&
    !checking
  ) {
    if (roles && props.redirect && !isLoggedIn) {
      // return <>{}</>;
      history.push("/login?returnto=" + encodeURI(history.location.pathname));
    }

    return null;
  }

  if (showLoading && (loading || checking))
    return <div style={{ padding: 20, fontSize: 14 }}>Loading...</div>;

  if (loading || checking) return null;

  return <>{props.children}</>;
};
